import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ConsoleLogger } from '@microsoft/signalr/dist/esm/Utils';
import { DxDataGridModule, DxButtonModule, DxDataGridComponent, DxSelectBoxModule } from "devextreme-angular";
import { EditingTexts } from 'devextreme/ui/data_grid';
import { custom } from 'devextreme/ui/dialog';
import { AppGlobals } from 'src/app/app.globals';
import { ConfigService } from 'src/app/services/config.service';
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";

import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
@Component({
    selector: 'app-config-property',
    imports: [
    SvgIconComponent,DxDataGridModule, DxButtonModule, DxSelectBoxModule, GpdButtonComponent],
    templateUrl: './config-property.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './config-property.component.css'
})
export class ConfigPropertyComponent {

  @ViewChild("documentTypesGrid", { static: false }) documentTypesGrid: DxDataGridComponent;
  @ViewChild("propertyAreaTypesGrid", { static: false }) propertyAreaTypesGrid: DxDataGridComponent;

  documentTypes: any = [];
  propertyAreaTypes: any = [];
  userPermissions: any = AppGlobals.UserPermissions;

  newId = 0;
  deletePopup: any;

  editText: EditingTexts = {
    cancelRowChanges: $localize`:@@cancel: Cancel`,
    saveRowChanges: $localize`:@@save: Save`,
  };

  constructor(private configService: ConfigService, private activityLog: ActivityLogService) {
    this.validateDocumentTypeDuplicateName =
      this.validateDocumentTypeDuplicateName.bind(this);

    this.validateDocumentTypeDuplicateCode = 
      this.validateDocumentTypeDuplicateCode.bind(this);  

    this.validatePropertyAreaTypeDuplicateName =
      this.validatePropertyAreaTypeDuplicateName.bind(this);
  }

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_PROPERTY });
 
    this.configService.getPropertyDocumentTypes({}).then((result) => {
      this.documentTypes = result.documentTypes;
    });

    this.configService.getPropertyAreaTypes({}).then((result) => {
      this.propertyAreaTypes = result.propertyAreaTypes;
    });
  }
  
  getNewId() {
    this.newId = this.newId - 1;
    return this.newId;
  }


  /************* Property Document Types *************/

  addNewContractType() {
    this.documentTypesGrid.instance.addRow();
  }

  editDocumentType(id: any) {
    let visibleRows = this.documentTypesGrid.instance.getVisibleRows();

    let index = null;

    visibleRows.some((row: any) => {
      if (row.data.id === id) {
        index = row.rowIndex;
        return true;
      }
    });

    this.documentTypesGrid.instance.editRow(index);
  }

  deleteDocumentType(itemToDelete: any) {
    let deleteDialog = custom({
      title: $localize`:@@confirmDeletionTitle:Confirm deletion`,
      messageHtml:
        "<i>" +
        $localize`:@@confirmDeletionItemMessage:Do you want to delete this item?` +
        "</i>",
      buttons: [
        { text: $localize`:@@yes:Yes`, onClick: () => true },
        { text: $localize`:@@no:No`, onClick: () => false },
      ],
    });

    deleteDialog.show().done((dialogResult) => {
      if (dialogResult) {

        let payload = {
          id: itemToDelete.id,
        };
       
        this.configService.deletePropertyDocumentType({DocumentType: payload }).then((result) => {
          this.configService.getPropertyDocumentTypes({}).then((result) => {
            this.documentTypes = result.documentTypes;
          });
        });
      }
    });
  }

  saveDocumentType(e: any) {
     
    let payload = {
      id: e.changes[0].data.id ?? this.getNewId(),
      documentType: e.changes[0].data.documentType,
      code: e.changes[0].data.code
    }

    this.configService.savePropertyDocumentType({DocumentType: payload }).then((result) => {
      this.configService.getPropertyDocumentTypes({}).then((result) => {
        this.documentTypes = result.documentTypes;
      });
    });
  }

  /************* Property Area Types *************/

  addNewPropertyAreaType() {
    this.propertyAreaTypesGrid.instance.addRow();
  }

  editPropertyAreaType(arg0: any) {
    let visibleRows = this.propertyAreaTypesGrid.instance.getVisibleRows();

    let index = null;

    visibleRows.some((row: any) => {
      if (row.data.id === arg0) {
        index = row.rowIndex;
        return true;
      }
    });

    this.propertyAreaTypesGrid.instance.editRow(index);
  }

  savePropertyAreaType(e: any) {
    let payload = {
      id: e.changes[0].data?.id ?? this.getNewId(),
      name: e.changes[0].data.name ?? e.changes.name,
    };

    console.log("Saving Property Area Type: ", payload);

    this.configService.writePropertyAreaType({ PropertyAreaType: payload }).then((result) => {
      console.log("Property Area Type saved: ", result);
    });
  }

  deletePropertyAreaType(itemToDelete: any) {
    let deleteDialog = custom({
      title: $localize`:@@confirmDeletionTitle:Confirm deletion`,
      messageHtml:
        "<i>" +
        $localize`:@@confirmDeletionItemMessage:Do you want to delete this item?` +
        "</i>",
      buttons: [
        { text: $localize`:@@yes:Yes`, onClick: () => true },
        { text: $localize`:@@no:No`, onClick: () => false },
      ],
    });

    deleteDialog.show().done((dialogResult) => {
      if (dialogResult) {
        let payload = {
          id: itemToDelete.id,
        };

        this.configService.deletePropertyAreaType({ PropertyAreaType: payload }).then((result) => {
          this.configService.getPropertyAreaTypes({}).then((result) => {
            this.propertyAreaTypes = result.propertyAreaTypes;
          });
        });
      }
    });
  }

  /************* Validation Callbacks *************/

  validateDocumentTypeDuplicateName(e) {
    const contractTypeExists = this.documentTypes.some(
      (contractType: any) => contractType.documentType == e.value
    );
    return !contractTypeExists;
  }

  validateDocumentTypeDuplicateCode(e) {
    const contractTypeExists = this.documentTypes.some(
      (contractType: any) => contractType.code == e.value
    );
    return !contractTypeExists;
  }

  validatePropertyAreaTypeDuplicateName(e) {
    const propertyAreaTypeExists = this.propertyAreaTypes.some(
      (propertyAreaType: any) => propertyAreaType.name == e.value
    );
    return !propertyAreaTypeExists;
  }
}
